/**
 * SJH Booking Bar & Booking Engine tracking events
 * (concept "Tracking Booking Bar & Booking Engine", Version 3 / August 2026).
 * Mirror of BBCustomEventsEnum in DiscoverSwiss.WebComponents: the web components dispatch
 * `dsCheckout_<GA4 event name>` window events, app.component pushes them into the dataLayer.
 */
export enum BBCustomEventsEnum {
    // a) Booking Bar - hostel selection
    BB_HOSTELPICKER_OPEN = 'dsCheckout_bb_hostelpicker_open',
    BB_GUESTPICKER_OPEN = 'dsCheckout_bb_guestpicker_open',
    BB_DATEPICKER_OPEN = 'dsCheckout_bb_datepicker_open',
    BB_HOSTELPICKER_SEARCH_TEXT = 'dsCheckout_bb_hostelpicker_search_text',
    BB_HOSTELPICKER_SHOWHIDE_LIST = 'dsCheckout_bb_hostelpicker_showhide_list',
    BB_HOSTELPICKER_USE_FILTERS = 'dsCheckout_bb_hostelpicker_use_filters',
    BB_HOSTELPICKER_SEARCH_MAP = 'dsCheckout_bb_hostelpicker_search_map',
    BB_HOSTELPICKER_SHOW_DETAILS = 'dsCheckout_bb_hostelpicker_show_details',
    BB_CLOSE = 'dsCheckout_bb_close',
    BB_HOSTEL_SELECT = 'dsCheckout_bb_hostel_select',

    // b) Booking Bar - hostel details (Stage 1)
    BB_HOSTELDETAIL_PICTURESLIDE = 'dsCheckout_bb_hosteldetail_pictureslide',
    BB_HOSTELDETAIL_OPENHOSTELSITE = 'dsCheckout_bb_hosteldetail_openhostelsite',
    BB_HOSTELDETAIL_BACK = 'dsCheckout_bb_hosteldetail_back',

    // c) Booking Bar - guests
    BB_GUESTPICKER_TYPE = 'dsCheckout_bb_guestpicker_type',
    BB_GUESTPICKER_BARRIERFREE = 'dsCheckout_bb_guestpicker_barrierfree',
    BB_GUESTPICKER_MEMBER = 'dsCheckout_bb_guestpicker_member',
    BB_GUEST_SELECT = 'dsCheckout_bb_guest_select',

    // d) Booking Bar - dates
    BB_DATEPICKER_CHECK_IN_OUT = 'dsCheckout_bb_datepicker_check_in_out',
    BB_DATE_SELECT = 'dsCheckout_bb_date_select',

    // Booking Engine - step 4 loaded
    BOOKING_PROCESS_STARTED = 'dsCheckout_booking_process_started',

    // e) Booking Engine - bed selection
    BE_ROOM_GENDER_OPTIONS = 'dsCheckout_be_room_gender_options',
    BE_ROOM_MEMBER = 'dsCheckout_be_room_member',
    BE_ROOM_BEDPICKER_QUANTITY = 'dsCheckout_be_room_bedpicker_quantity',

    // f) Booking Engine - options 1
    BE_OPTIONS_MEALS_PICKER = 'dsCheckout_be_options_meals_picker',
    BE_OPTIONS_MEALS_DATEPICKER = 'dsCheckout_be_options_meals_datepicker',
    BE_OPTIONS_MEALS_QUANTITY = 'dsCheckout_be_options_meals_quantity',
    BE_OPTIONS_MEALS_DIAT = 'dsCheckout_be_options_meals_diat',
    BE_OPTIONS_PARKING_QUANTITY = 'dsCheckout_be_options_parking_quantity',
    BE_OPTIONS_DOG_QUANTITY = 'dsCheckout_be_options_dog_quantity',
    BE_OPTIONS_STEPBACK = 'dsCheckout_be_options_stepback',

    // g) Booking Engine - options 2
    BE_OPTIONS_ADDITIONALSTY = 'dsCheckout_be_options_additionalsty',
    BE_OPTIONS_MEMBERSHIP = 'dsCheckout_be_options_membership',
    BE_OPTIONS_PARTNEROFFERS = 'dsCheckout_be_options_partneroffers',
    BE_OPTIONS_PUBLICTRANSPORT = 'dsCheckout_be_options_publictransport',

    // h) Booking Engine - view cart
    BE_VIEW_CART_OPEN = 'dsCheckout_be_view_cart_open',
    BE_VIEW_CART_EDIT_ITEM = 'dsCheckout_be_view_cart_edit_item',
    BE_VIEW_CART_DELETE_ITEM = 'dsCheckout_be_view_cart_delete_item',
    BE_VIEW_CART_ADD_CLIMATE_CONTRIBUTION = 'dsCheckout_be_view_cart_add_climate_contribution',
    BE_VIEW_CART_ADD_OPTION_INSURANCE = 'dsCheckout_be_view_cart_add_option_insurance',
    BE_VIEW_CART_DELETE_PARTNER_OFFER = 'dsCheckout_be_view_cart_delete_partner_offer',
    BE_VIEW_CART_DONATION = 'dsCheckout_be_view_cart_donation',
    BE_VIEW_CART_APPLY_PROMOCODE = 'dsCheckout_be_view_cart_apply_promocode',
    BE_VIEW_CART_NEWSLETTER_SIGNUP = 'dsCheckout_be_view_cart_newsletter_signup',

    // i) Booking Engine - login
    BE_LOGIN_CONTINUE_AS_GUEST = 'dsCheckout_be_login_continue_as_guest',
    BE_LOGIN_OPEN_ACCOUNT = 'dsCheckout_be_login_open_account',

    // j) Booking Engine - payment
    BE_PAYMENT_START = 'dsCheckout_be_payment_start',

    // k) Booking Engine - confirmation
    BE_RESTART = 'dsCheckout_be_restart',

    // GA4 e-commerce events
    ADD_TO_CART = 'dsCheckout_add_to_cart',
    BEGIN_CHECKOUT = 'dsCheckout_begin_checkout',
    PURCHASE = 'dsCheckout_purchase',
}
